import { render, staticRenderFns } from "./AiBookTotalRuleConfig.vue?vue&type=template&id=7a57d60f&scoped=true"
import script from "./AiBookTotalRuleConfig.vue?vue&type=script&lang=js"
export * from "./AiBookTotalRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a57d60f",
  null
  
)

export default component.exports